import React from "react";
import classNames from "classnames";
import style from "./style.scss";

export const BoxRank = ({ rank, children }) => {
    return (
        <div
            className={classNames(style.rank, {
                [style.low]: rank === "low",
                [style.mid]: rank === "mid",
                [style.high]: rank === "high",
                [style.missing]: rank === "missing"
            })}
        >
            <div className={style.label}>{children}</div>
        </div>
    );
};
